"use client";

import { useTranslations } from "next-intl";
import { EventLandingPage } from "@types";
import LandingPageLinkV2 from "../../../components/links/landingPageLinkV2";
import { Text } from "@components/theming";

interface Props {
  landingPages: EventLandingPage[];
}

export default function CartNotificationUpsell({ landingPages }: Props) {
  const t = useTranslations("Notification");

  return (
    <div className="flex flex-col gap-4 md:gap-2 mt-2">
      <Text as="p" sharedClasses="text-sm font-semibold text-center">
        {t("exploremore", {
          landingpages: landingPages
            .map((v, i) => {
              return landingPages.length === 1
                ? v.title
                : landingPages.length === i + 2
                ? `${v.title} & `
                : landingPages.length > i + 1
                ? `${v.title}, `
                : v.title;
            })
            .join(""),
        })}
      </Text>
      {landingPages.map((landingpage) => (
        <LandingPageLinkV2
          key={landingpage.id}
          slug={landingpage.url}
          image={landingpage.images.header}
          name={landingpage.title}
          showNameOnMobile={landingPages.length > 1}
        />
      ))}
      <Text as="p" sharedClasses="text-center text-sm md:mt-2">
        {t("or")}
      </Text>
    </div>
  );
}
